import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { Routes, Route, Navigate } from "react-router-dom";
import BusinessClients from "../Pages/Steps/1BusinessClients/BusinesClients";
import Processing from "../Pages/Steps/2Processing/Processing";
import Review from "../Pages/Steps/4ToReview/Review";
import Ready from "../Pages/Steps/5Ready/Ready";
import Exported from "../Pages/Steps/6Exported/Exported";
import Archive from "../Pages/Steps/7Archive/Archive";
import Inbox from "../Pages/Steps/3Inbox/Inbox";
import BusinessSettings from "../Pages/BusinessSettings/BusinessSettings";
import { Check } from "./check";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import { Login } from "../Pages/Authentication/New-pages/Login";

import {UserManagement }from "../Pages/Usermanagement/Usermanagement";
import ForgotPassword from "../Pages/Authentication/New-pages/mfa/index";
import { SetPasswordPage } from "../Pages/Authentication/New-pages/SetPasswordPage/SetPasswordPage";
import { Register } from "../Pages/Authentication/New-pages/Register/Register";
import { PublicDocument } from "../Pages/PublicImageViewer";
import Overview from "../Pages/Overview/Overview";
import DuplicateInvoiceCompare from "../Components/DuplicateInvoiceCompare/DuplicateInvoiceCompare";
import { SubmissionHistory } from "../Pages/SubmissionHistory/SubHistory";


interface AppRoutes {
  component: React.FC;
  path: string;
}

const homeRoutesClient: AppRoutes[] = [
  {
    component: Overview,
    path: "overview",
  },
  {
    component: Processing,
    path: "",
  },
];

const homeRoutesAdmin: AppRoutes[] = [
  {
    component: Overview,
    path: "overview",
  },
  {
    component: Inbox,
    path: "inbox",
  },
  {
    component: BusinessClients,
    path: "/",
  },
  {
    component: Processing,
    path: "processing",
  },
  {
    component: Review,
    path: "to-review",
  },
  {
    component: Ready,
    path: "ready",
  },
  {
    component: Exported,
    path: "exported",
  },
  {
    component: Archive,
    path: "archive",
  },
  {
    component: UserManagement,
    path: "user-management",
  },
  {
    component: SubmissionHistory,
    path: "submission-history",
  },
  {
    component: BusinessSettings,
    path: "Business-settings",
  },
  {
    component: DuplicateInvoiceCompare,
    path: "inbox/duplicate-invoice-compare",
  }
];

const AppRoutes = () => {
  var userType = useSelector((state: RootState) => state.auth.userType);
  // const isAuthenticated = useSelector(
  //   (state: RootState) => state.auth.isAuthenticated
  // );
  //const user = JSON.parse(localStorage.getItem("user") || "{}");
  //const userRole = user.roleId;
  // console.log("User Role ID:", userRole);
  if (userType === 565) {
    const savedType = localStorage.getItem("userType");

    userType = savedType ? parseInt(savedType, 10) : 565;
  }

  const homeRoutes = userType === 1 ? homeRoutesClient : homeRoutesAdmin;
  // const homeRoutes = homeRoutesAdmin;
  //  let homeRoutes: AppRoutes[] = homeRoutesClient;

  // switch (userRole) {
  //   case 0:
  //     homeRoutes = homeRoutesAdmin;
  //     break;s
  //   case 1:
  //     homeRoutes = homeRoutesClient;
  //     break;
  //   // default:
  //   //   var homeRoutes = [];
  // }
  return (
    <Routes>
      {/* ----------- PUBLIC ROUTES ----------- */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/password-reset/"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/password-reset/:email"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route
        path="/register/:email"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route
        path="/password-set/:token/:email/:fullName"
        element={
          <PublicRoute>
            <SetPasswordPage />
          </PublicRoute>
        }
      />
      <Route
        path="/i/:id"
        element={
          <PublicRoute>
            <PublicDocument />
          </PublicRoute>
        }
      />

      {/* <Route path="/register" element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      } />

      <Route path="/reset-password" element={
        <PublicRoute>
          <PasswordReset />
        </PublicRoute>
      } /> */}

      {/* ============ PROTECTED ROUTES (inside AppLayout) ============ */}
      {/* redirect / -> /home */}

      {homeRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            <ProtectedRoute>
              <route.component />
            </ProtectedRoute>
          }
        />
      ))}

      {/* 
      {homeRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={ <ProtectedRoute>
              <route.component />
            </ProtectedRoute>} />
      ))}  */}
    </Routes>
  );
};

export default AppRoutes;
